import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ViewController
} from "ionic-angular";
import * as papa from "papaparse";
import { DatabaseProvider } from '../../providers/database/database';
import * as _ from "lodash";
import { AuthProvider } from "../../providers/auth/auth";
@IonicPage()
@Component({
  selector: 'page-admin-supplies-upload',
  templateUrl: 'admin-supplies-upload.html',
})
export class AdminSuppliesUploadPage {
  uploadedSupplies: Array<Object> = [];
  message: string = null;
  clinic_name: string = null;
  clinic_id: string = null;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    private viewCtrl: ViewController
  ) {

    this.auth.getCurrentUser().then(user => {
      console.log(user);
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
    });
  }

  parseCSV(files: FileList): void {
    let loading = this.loadingCtrl.create({
      content: "Uploading and checking supply info..."
    });

    loading.present().then(_ => {
      const file: File = files.item(0);
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = e => {
        const csv = reader.result;
        //const parsed = papa.parse(csv, {
        papa.parse(csv, {
          // dynamicTyping: true,
          header: true,
          complete: () => {
            console.log("Completed Data", this.uploadedSupplies);
            loading.dismiss();
          },
          error: error => {
            console.error(error.message);
            loading.dismiss();
          },
          step: row => {
            if (row.data[0]['strength'] === '') { row.data[0]['strength'] = null; }
            
            if (row.data[0]['size'] === '') { row.data[0]['size'] = null; }

            if (row.data[0]['unit'] === '') { row.data[0]['unit'] = null; }

            this.uploadedSupplies.push(row.data[0]);
            console.log(row.data[0]);
          }
        });
      };
    });
  }

  completeUpload() {
    let confirm = this.alertCtrl.create({
      title: "Add Supplies?",
      message:
        "Are you sure you would like to add " +
        this.uploadedSupplies.length +
        " supplies?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't upload supplies");
          }
        },
        {
          text: "Yes",
          handler: () => {
            const loading = this.loadingCtrl.create({});
            loading.present();
            console.log(this.uploadedSupplies.length)
            this.uploadedSupplies.forEach(async (supply, idx) => {
              supply['sort'] = idx;
              await this.saveSupply(supply);
              
            })
            loading.dismiss();
            this.dismiss();
            // _.forEach(this.uploadedSupplies, async (row, idx) => {
            //   row['sort'] = idx;
            //   await this.saveSupply(row);
            //   console.log(idx + ' - ' + row);
            //   if(this.uploadedSupplies.length === (idx + 1)) {
            //     loading.dismiss();
            //     this.dismiss();
            //   }
            // });
          }
        }
      ]
    });
    confirm.present();
  }

  async saveSupply(row) {
    await this.database
      .addSupply(row)
      .then(response => {
        row.id = response["data"].id;
        return true;
      })
      .catch(err => {
        return false;
      });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-supplies-upload/admin-supplies-upload.ts